import { lazy, Suspense } from 'react';

import { SplashScreen } from 'src/components/loading-screen';

const DisplayPage = lazy(() => import('src/pages/display/page'));

export const displayRoutes = [
  {
    path: 'display',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <DisplayPage />
      </Suspense>
    ),
  },
];
